import { formatMoney } from "@/lib/money";
import { cn } from "@/lib/utils";

interface UpfrontPaidDisplayProps {
  amountCents: number;
  className?: string;
}

export function UpfrontPaidDisplay({
  amountCents,
  className,
}: UpfrontPaidDisplayProps) {
  return (
    <span
      className={cn(
        "text-xs font-medium tabular-nums text-surface-700 sm:text-sm",
        className,
      )}
    >
      {formatMoney(amountCents)}
    </span>
  );
}
